/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Block_WhiteInputs */

const en_orders_review_block_white = /** @type {(inputs: Orders_Review_Block_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order is still white and must be reviewed before shipping.`)
};

const es_orders_review_block_white = /** @type {(inputs: Orders_Review_Block_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El pedido sigue en blanco y debe revisarse antes del envio.`)
};

/**
* | output |
* | --- |
* | "Order is still white and must be reviewed before shipping." |
*
* @param {Orders_Review_Block_WhiteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_block_white = /** @type {((inputs?: Orders_Review_Block_WhiteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Block_WhiteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_block_white(inputs)
	return es_orders_review_block_white(inputs)
});